import React, { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { apiGet } from "@/lib/api";

const LOW_STOCK_THRESHOLD = 25;

const LowStockAlert = () => {
  const [low, setLow] = useState(null);

  useEffect(() => {
    const load = () =>
      apiGet("/api/hype")
        .then((d) => {
          const z = (d.zones || []).find(
            (z) => z.available > 0 && z.available < LOW_STOCK_THRESHOLD
          );
          setLow(z ? { id: z.id, label: z.label, available: z.available } : null);
        })
        .catch(() => {});
    load();
    const t = setInterval(load, 45000);
    return () => clearInterval(t);
  }, []);

  if (!low) return null;

  return (
    <div
      data-testid="low-stock-alert"
      className="fixed top-16 sm:top-20 left-1/2 -translate-x-1/2 z-40 w-[92%] max-w-lg rounded-full border border-[#F59E0B]/50 bg-[#1a1206]/95 backdrop-blur px-5 py-2.5 flex items-center justify-center gap-2.5 shadow-[0_8px_30px_rgba(245,158,11,0.25)] low-stock-pulse"
    >
      <AlertTriangle size={14} className="text-[#F59E0B] shrink-0" />
      <p className="text-[11px] sm:text-xs text-[#F3D068] tracking-wide text-center leading-snug">
        Seats almost gone — only <b>{low.available}</b> left in {low.label}.
        <span className="hidden sm:inline"> Once they're gone, they're gone.</span>
      </p>
    </div>
  );
};

export default LowStockAlert;
